const pick = (object, keys) => {
  return Object.keys(object).filter(key => keys.includes(key)).reduce((acculumatedObject, key) => Object.assign({}, acculumatedObject, {
    [key]: object[key]
  }), {});
};
export default pick;